import CharacteristicInlineBlock from './CharacteristicInlineBlock.vue'

export default CharacteristicInlineBlock
